<template>
  <fragment>
    <div v-if="activityStatus==3" class="swiper-wrapper">
      <template v-if="swiperList.length">
        <swiper :auto-update="true" :auto-destroy="true" :delete-instance-on-destroy="true"
          :cleanup-styles-on-destroy="true" ref="swiperInstance" :options="swiperOptions">
          <swiper-slide :style="swiperStyle" :key="index" v-for="(item, index) in swiperList">
            <div :class="['swiper-item', 'swiper-item-' + item.tag, screenRatio ? 'swiper-item-' + item.tag + '-x': '']"
              :style="{'background-image': 'url('+ item.content.img.bg +')'}">
              <template v-if="item.tag != 'part7'">
                <div class="swiper-line" :style="subItem.style" :key="subIndex"
                  v-for="(subItem, subIndex) in item.content.dom"><span
                    :class="['line-item', childItem.em ? 'line-item-em' : '']" :key="childIndex"
                    v-for="(childItem, childIndex) in subItem.text">{{childItem.tt || childItem.em}}</span></div>
              </template>
              <template v-else>
                <template v-if="newUser">
                  <div class="part7" :style="screenRatio ? 'padding-top:' + 80 * (1-widthPercent) + 'px' : ''">
                    <div class="part7-content" :style="{'background-image': 'url('+ item.content.img.content +')'}">
                      <div :style="subItem.style" :key="subIndex" v-for="(subItem, subIndex) in item.content.dom">
                        <span :key="childIndex" v-for="(childItem, childIndex) in subItem.text">{{childItem.tt ||
                        childItem.bb || childItem.ll}}</span>
                      </div>
                      <img class="logo" :src="imgs.logo" alt="" />
                      <div v-if="isWechat" class="qrcode-wrapper">
                        <img class="qrcode" :src="imgs.qrcode" alt="" />
                      </div>
                    </div>
                    <div :class="['capture-tips', !screenRatio ? 'capture-tips-s' : '']">
                      *截图分享你的新年好运词
                    </div>
                    <div :class="['handle-btn', 'handle-single', !screenRatio ? 'handle-btn-s' : '']">
                      <div class="btn-item" @click="handleClick('rule')">前往抽奖</div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="part7" :style="screenRatio ? 'padding-top:' + 80 * (1-widthPercent) + 'px' : ''">
                    <div class="part7-content" :style="{'background-image': 'url('+ item.content.img.content +')'}">
                      <div :style="subItem.style" :key="subIndex" v-for="(subItem, subIndex) in item.content.dom">
                        <span :key="childIndex" v-for="(childItem, childIndex) in subItem.text">{{childItem.tt ||
                        childItem.bb || childItem.ll}}</span>
                      </div>
                      <img class="logo" :src="imgs.logo" alt="" />
                      <div v-if="isWechat" class="qrcode-wrapper">
                        <img class="qrcode" :src="imgs.qrcode" alt="" />
                      </div>
                    </div>
                    <div :class="['capture-tips', !screenRatio ? 'capture-tips-s' : '']">
                      *截图分享你的“电量”账单
                    </div>
                    <div :class="['handle-btn', 'handle-double',  !screenRatio ? 'handle-btn-s' : '']">
                      <div class="btn-item reverse-item" @click="handleClick('swiper')">回看账单</div>
                      <div class="btn-item" @click="handleClick('rule')">前往抽奖</div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="item.tag == 'part4'">
                <div class="cover-city">至今，怪兽充电已覆盖地区1600+</div>
              </template>
            </div>
          </swiper-slide>
        </swiper>
        <div class="slide-tips" v-if="showSlider">
          <img class="slide-icon" :src="imgs.slideTips" alt="" />
        </div>
        <div class="audio-wrapper" v-if="showAudio">
          <BillAudio :info="audioOptions" />
        </div>
      </template>
    </div>
  </fragment>
</template>

<script>

import { isMiniApplets } from "@/utils/browser";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import BillAudio from './components/audio.vue'

import "swiper/css/swiper.css";

let part7ContentTotal = {
  wechat: {
    a: 'https://static.enmonster.com/1356535345680035840',
    b: 'https://static.enmonster.com/1356535416999981056',
  },
  alipay: {
    a: 'https://static.enmonster.com/1356535479818072064',
    b: 'https://static.enmonster.com/1356535529952587776'
  }
}

let isWechat = isMiniApplets() == 'wechat'

let part7Content = isWechat ? part7ContentTotal['wechat'] : part7ContentTotal['alipay']

let screenRatioFun = () => { return (window.innerWidth / window.innerHeight).toFixed(2) }

let screenRatio = isNaN(screenRatioFun()) || screenRatioFun() < 0.6

let widthPercent = isNaN(screenRatioFun()) ? 0.55 : screenRatioFun()

let widthRatio = isNaN((window.innerWidth / 375).toFixed(2)) ? 1 : (window.innerWidth / 375).toFixed(2)


const imgs = { // img 的 a/b/c 分支和 swiper 数据对应
  part1: 'https://static.enmonster.com/1351462493947768832',
  part2: 'https://static.enmonster.com/1351462544560435200',
  part3: {
    a: 'https://static.enmonster.com/1351462627704123392',
    b: 'https://static.enmonster.com/1351462691780505600'
  },
  part4: 'https://static.enmonster.com/1351462745866055680',
  part5: 'https://static.enmonster.com/1351462803273494528',
  part6: {
    a: 'https://static.enmonster.com/1351462853785497600',
    b: 'https://static.enmonster.com/1351462913214590976',
    c: 'https://static.enmonster.com/1351462974019416064'
  },
  part7: 'https://static.enmonster.com/1356535274284593152',
  part7Content: part7Content,
  logo: 'https://static.enmonster.com/1351463248452726784',
  qrcode: 'https://static.enmonster.com/hdb/annual-bill-qrcode',
  slideTips: 'https://static.enmonster.com/1351463188553871360',
  audio: 'https://static.enmonster.com/1354739336658366464',
  musicClosed: 'https://static.enmonster.com/1351844250245214208',
  musicOpen: 'https://static.enmonster.com/1351844298475515904',
  tag: 'https://static.enmonster.com/1356535583966834688'
}

const attrObj = { // 默认属性对象
  part1: {
    nickName: null,
    regDurationYear: null,
    firstOrderCity: null,
    firstOrderElapsedDuration: null
  },
  part2: {
    a: { // 使用不足10小时的用户
      orderQt: null,
      useDuration: null
    },
    b: { // 使用10小时以上的用户
      orderQt: null,
      useDuration: null,
      rankPercent: null,
      gameDuration: null,
      tvDuration: null,
      tiktokDuration: null
    }
  },
  part3: {
    a: { // 2月-4月有订单
      firstOrderMonthByP3: null
    },
    b: {} // 2月-4月无订单
  },
  part4: {
    a: { // 下单城市只有1个
      orderCityListTxt: null
    },
    b: { // 下单城市2个及以上
      orderCityListTxt: null
    }
  },
  part5: {
    orderMostCategoryTxt: null,
    orderMostCategoryQt: null,
    orderMostCategoryInfo1: null,
    orderMostCategoryInfo2: null,
    orderMostCategoryInfo3: null
  },
  part6: {
    a: { // 21点-5点的时间段存在下单
      latestOrderDateMonth: null,
      latestOrderDateDay: null,
      latestOrderDateHour: null
    },
    b: { // 5点到8点的时间段存在下单
      earliestOrderDateMonth: null,
      earliestOrderDay: null,
      earliestOrderHour: null
    },
    c: {} // 以上都不满足
  },
  part7: {
    a: { // 2020/2/1-2021/1/31 期间未下过单
      nickName: null,
      luckyWordTxt: null
    },
    b: { // 020/2/1-2021/1/31 期间下过单
      nickName: null,
      luckyWordTxt: null,
      tagP2Txt: null,
      tagP3Txt: null,
      tagP4Txt: null,
      tagP5Txt: null,
      tagP6Txt: null
    }
  }
}

const textObj = { // 默认文案对象
  part1: [
    [{ tt: '嘿，${nickName}' }],
    [{ tt: '这是陪伴你的第' }, { em: '${regDurationYear}' }, { tt: '年！' }],
    [{ tt: '你还记得' }, { em: '${firstOrderCity}' }, { tt: '吗？' }],
    [{ tt: '在那里我们第一次相遇了，' }],
    [{ tt: '距今已经过去了' }, { em: '${firstOrderElapsedDuration}' }, { tt: '天。' }]
  ],
  part2: {
    a: [
      [{ tt: '今年，你一共使用了' }, { em: '${orderQt}' }, { tt: '次充电宝' }],
      [{ tt: '共计' }, { em: '${useDuration}' }, { tt: '个小时，' }],
      [{ tt: '希望你需要的时候，' }],
      [{ tt: '我的电力都能给你温暖陪伴。' }]
    ],
    b: [
      [{ tt: '今年，你一共使用了' }, { em: '${orderQt}' }, { tt: '次充电宝， 共计' }],
      [{ em: '${useDuration}' }, { tt: '个小时，超越了' }, { em: '${rankPercent}%' }, { tt: '用户' }],
      [{ tt: '提供的电能大约可以供你' }],
      [{ tt: '打' }, { em: '${gameDuration}' }, { tt: '局王者排位赛，' }],
      [{ tt: '追完' }, { em: '${tvDuration}' }, { tt: '集电视剧，' }],
      [{ tt: '刷' }, { em: '${tiktokDuration}' }, { tt: '小时抖音......' }],
      [{ tt: '希望能给你温暖陪伴！' }]
    ],
  },
  part3: {
    a: [
      [{ tt: '2020年是特别的一年。' }],
      [{ tt: '你在' }, { em: '${firstOrderMonthByP3}' }, { tt: '月使用过怪兽充电，' }],
      [{ tt: '这个时候还在外奔波一定有很重要的事情吧。' }],
      [{ tt: '感谢奋斗在一线的人们，' }],
      [{ tt: '让大家的生活可以持续运转。' }]
    ],
    b: [
      [{ tt: '2020年是特别的一年。' }],
      [{ em: '2' }, { tt: '月-' }, { em: '4' }, { tt: '月，你没有使用充电宝，' }],
      [{ tt: '为了早日恢复生活，' }],
      [{ tt: '宅家这么久，真的辛苦了！' }],
      [{ tt: '新的一年，希望我们都能平安健康！' }]
    ]
  },
  part4: {
    a: [
      [{ tt: '在我们的共同努力下，' }],
      [{ tt: '生活逐步恢复。' }],
      [{ tt: '你的身影穿梭于' }, { em: '${orderCityListTxt}' }, { tt: '，无论多久不见，' }],
      [{ tt: '我都会在某个街角默默守护你。' }]
    ],
    b: [
      [{ tt: '在我们的共同努力下，生活逐步恢复。' }],
      [{ tt: '宅家的日子开始接近尾声，' }],
      [{ tt: '你去了' }, { em: '${orderCityListTxt}' }, { tt: '，' }],
      [{ tt: '并在这里找到了我。' }],
      [{ tt: '现在的你回到家人身边了吗？' }],
      [{ tt: '抱抱他们，给累了一年的自己充充电吧！' }]
    ]
  },
  part5: [
    [{ tt: '生活恢复了以往的节奏，' }],
    [{ tt: '街边的门市也热闹了起来。' }],
    [{ tt: '这一年，你经常出现在' }, { em: '${orderMostCategoryTxt}' }, { tt: '，' }],
    [{ tt: '并在那里使用了' }, { em: '${orderMostCategoryQt}' }, { tt: '次怪兽充电，' }],
    [{ tt: '${orderMostCategoryInfo1}' }],
    [{ tt: '${orderMostCategoryInfo2}' }],
    [{ tt: '${orderMostCategoryInfo3}' }],
  ],
  part6: {
    a: [
      [{ em: '${latestOrderDateMonth}' }, { tt: '月' }, { em: '${latestOrderDateDay}' }, { tt: '日，' }],
      [{ tt: '这天' }, { em: '${latestOrderDateHour}' }, { tt: '点是你去年最晚的一次使用，' }],
      [{ tt: '城市还在沉睡，' }],
      [{ tt: '怪兽充电的陪伴24小时不寐！' }]
    ],
    b: [
      [{ em: '${earliestOrderDateMonth}' }, { tt: '月' }, { em: '${earliestOrderDay}' }, { tt: '日，' }],
      [{ tt: '这天' }, { em: '${earliestOrderHour}' }, { tt: '点是你去年最早的一次使用，' }],
      [{ tt: '看来那段时间一定很忙很累吧，' }],
      [{ tt: '需要充电的时候，记得来找我哦！' }]
    ],
    c: [
      [{ tt: '你的订单时间都集中在' }, { em: '08' }, { tt: '点-' }, { em: '21' }, { tt: '点，' }],
      [{ tt: '看来你的白天过的很忙碌哦，' }],
      [{ tt: '除了手机也别忘了停下来给自己“充个电”哦！' }]
    ]
  },
  part7: {
    a: [
      [{ tt: '${nickName}' }],
      [{ bb: '${luckyWordTxt}' }]
    ],
    b: [
      [{ tt: '${nickName}' }],
      [{ bb: '${luckyWordTxt}' }],
      [{ ll: '${tagP2Txt}' }],
      [{ ll: '${tagP3Txt}' }],
      [{ ll: '${tagP4Txt}' }],
      [{ ll: '${tagP5Txt}' }],
      [{ ll: '${tagP6Txt}' }]
    ]
  }
}

const styleObj = { // 默认样式对象
  part1: {
    img: {
      bg: imgs.part1,
    },
    styleList: [
      `padding-top:${screenRatio ? 50 : 32}px;padding-left:20px;`,
      'padding-left:20px',
      `padding-top:${screenRatio ? 55 : 29}px;padding-left:20px;`,
      'padding-left:20px',
      'padding-left:20px',
      'padding-left:20px'
    ]
  },
  part2: {
    a: {
      img: {
        bg: imgs.part2
      },
      styleList: [
        `padding-top:${screenRatio ? 27 : 10}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px'
      ]
    },
    b: {
      img: {
        bg: imgs.part2
      },
      styleList: [
        `padding-top:${screenRatio ? 27 : 4}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
      ]
    }
  },
  part3: {
    a: {
      img: {
        bg: imgs.part3.a
      },
      styleList: [
        `padding-top:${screenRatio ? 127 : 52}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
      ]
    },
    b: {
      img: {
        bg: imgs.part3.b
      },
      styleList: [
        `padding-top:${screenRatio ? 233 : 137}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
      ]
    }
  },
  part4: {
    a: {
      img: {
        bg: imgs.part4
      },
      styleList: [
        `padding-top:${screenRatio ? 148 : 81}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px;padding-right:20px',
        'padding-left:20px',
      ]
    },
    b: {
      img: {
        bg: imgs.part4
      },
      styleList: [
        `padding-top:${screenRatio ? 137 : 25}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px;padding-right:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
      ]
    }
  },
  part5: {
    img: {
      bg: imgs.part5
    },
    styleList: [
      `padding-top:${screenRatio ? 93 : 55}px;padding-left:20px`,
      'padding-left:20px',
      'padding-left:20px',
      'padding-left:20px',
      'padding-left:20px',
      'padding-left:20px',
      'padding-left:20px',
    ]
  },
  part6: {
    a: {
      img: {
        bg: imgs.part6.a
      },
      styleList: [
        `padding-top:${screenRatio ? 263 : 142}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
      ]
    },
    b: {
      img: {
        bg: imgs.part6.b
      },
      styleList: [
        `padding-top:${screenRatio ? 117 : 6}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
        'padding-left:20px',
      ]
    },
    c: {
      img: {
        bg: imgs.part6.c
      },
      styleList: [
        `padding-top:${screenRatio ? 82 : 197}px;padding-left:20px`,
        'padding-left:20px',
        'padding-left:20px',
      ]
    }
  },
  part7: {
    a: {
      img: {
        bg: imgs.part7,
        content: imgs.part7Content.a
      },
      styleList: [
        `padding-left:${28 * widthRatio}px;padding-top:${54 * widthRatio}px;color:#000;text-align:left;font-size:${19 * widthRatio}px;font-weight:600`,
        `width:100%;padding-top:${67 * widthRatio}px;line-height:${65 * widthRatio}px;text-align:center;font-size:${46 * widthRatio}px;font-weight:bold`,
      ]
    },
    b: {
      img: {
        bg: imgs.part7,
        content: imgs.part7Content.b,
        tag: imgs.tag
      },
      styleList: [
        `padding-left:${28 * widthRatio}px;padding-top:${54 * widthRatio}px;color:#000;text-align:left;font-size:${19 * widthRatio}px;font-weight:600`,
        `width:100%;padding-top:${67 * widthRatio}px;line-height:${65 * widthRatio}px;text-align:center;font-size:${46 * widthRatio}px;font-weight:bold`,
        `position:absolute;left:${34 * widthRatio}px;top:${255 * widthRatio}px;width:${128 * widthRatio}px;box-sizing:border-box;padding-left:${13 * widthRatio}px;height:${26 * widthRatio}px;background-image:url(${imgs.tag});background-repeat:no-repeat;background-size:${8 * widthRatio}px ${12 * widthRatio}px;background-position:left ${5}px;text-align:left;font-size:${14 * widthRatio}px;font-weight:bold;border-bottom:1px dashed #979797`,
        `position:absolute;left:${199 * widthRatio}px;top:${255 * widthRatio}px; width:${128 * widthRatio}px;box-sizing:border-box;padding-left:${13 * widthRatio}px;height:${26 * widthRatio}px;background-image:url(${imgs.tag});background-repeat:no-repeat;background-size:${8 * widthRatio}px ${12 * widthRatio}px;background-position:left ${5}px;text-align:left;font-size:${14 * widthRatio}px;font-weight:bold;border-bottom:1px dashed #979797`,
        `position:absolute;left:${34 * widthRatio}px;top:${294 * widthRatio}px;width:${128 * widthRatio}px;box-sizing:border-box;padding-left:${13 * widthRatio}px;height:${26 * widthRatio}px;background-image:url(${imgs.tag});background-repeat:no-repeat;background-size:${8 * widthRatio}px ${12 * widthRatio}px;background-position:left ${5}px;text-align:left;font-size:${14 * widthRatio}px;font-weight:bold;border-bottom:1px dashed #979797`,
        `position:absolute;left:${199 * widthRatio}px;top:${294 * widthRatio}px;width:${128 * widthRatio}px;box-sizing:border-box;padding-left:${13 * widthRatio}px;height:${26 * widthRatio}px;background-image:url(${imgs.tag});background-repeat:no-repeat;background-size:${8 * widthRatio}px ${12 * widthRatio}px;background-position:left ${5}px;text-align:left;font-size:${14 * widthRatio}px;font-weight:bold;border-bottom:1px dashed #979797`,
        `position:absolute;left:${34 * widthRatio}px;top:${333 * widthRatio}px;width:${128 * widthRatio}px;box-sizing:border-box;padding-left:${13 * widthRatio}px;height:${26 * widthRatio}px;background-image:url(${imgs.tag});background-repeat:no-repeat;background-size:${8 * widthRatio}px ${12 * widthRatio}px;background-position:left ${5}px;text-align:left;font-size:${14 * widthRatio}px;font-weight:bold;border-bottom:1px dashed #979797`,
      ]
    }
  }
}

const luckyWordList = [ // 幸运词列表
  '牛气冲天',
  '好运连连',
  '一夜暴富',
  '心态超好',
  '桃花不断',
  '发量王者',
  '逢买必涨',
  '欧气满满',
  '万象更新',
  '财富自由'
]

const shopInfo = { // 1餐饮 2银行 3酒店 4购物 5娱乐 6培训 7医疗 8交通 9丽人 10亲子 11政府机构 12营销活动(仅市场部) 13 写字楼 14 未知场所
  101: {
    name: '各种饭店',
    desc: ['让我们红尘作伴，', '一起为干饭举碗！']
  },
  104: {
    name: '银行',
    desc: ['将来的你，', '远远不止财富自由！']
  },
  105: {
    name: '酒店',
    desc: ['不在家的夜记得把月亮挂好哦！']
  },
  106: {
    name: '购物中心',
    desc: ['陪你逛街我是认真的！']
  },
  107: {
    name: '休闲娱乐场所',
    desc: ['休息时间的减压时刻，', '焦虑烦闷都闪开哦！']
  },
  108: {
    name: '培训机构',
    desc: ['攀登注定是孤独的旅程，', '怪兽充电永远为你护航！']
  },
  109: {
    name: '医疗场所',
    desc: ['你照顾好自己，', '我照顾好你的电量！']
  },
  110: {
    name: '交通场所',
    desc: ['不惧路途遥远，', '怪兽充电陪你披荆斩棘！']
  },
  111: {
    name: '美容美发场所',
    desc: ['你负责貌美如花，', '我是你电量的管家。'],
  },
  136: {
    name: '亲子场所',
    desc: ['怪兽充电陪你记录成长记录爱。']
  },
  165: {
    name: '政府机构',
    desc: ['既然遇见了那么多次，', '你的电量就交给我来守护吧！']
  },
  166: {
    name: '怪兽充电的活动场地',
    desc: ['很高兴遇见你！']
  },
  179: {
    name: '写字楼间',
    desc: ['打工人，', '打工魂，', '打工才是人上人！']
  },
  0: {
    name: '神秘的角落',
    desc: ['相信这里一定有什么在吸引着你吧！']
  }
}

const tag = { // 标签对象
  tagP2: [ // 
    '宇宙充电冠军',
    '宇宙电力协会会长',
    '电力经济学家',
    '电力管理达人',
  ],
  tagP3: [
    '防疫小能手',
    '星光赶路人'
  ],
  tagP4: [
    '城市探险家',
    '城际漫游者'
  ],
  tagP5: { // 1餐饮 2银行 3酒店 4购物 5娱乐 6培训 7医疗 8交通 9丽人 10亲子 11政府机构 12营销活动(仅市场部) 13 写字楼 14 未知场所
    101: '干饭艺术家',
    104: '未来巴菲特',
    105: '美梦种草机',
    106: '电量弄潮鹅',
    107: '快乐工程师',
    108: 'BOOK思议逐梦人',
    109: '电量守护者',
    110: '梦想摆渡师',
    111: '美貌管理大师',
    136: '人类幼崽观察员',
    165: '电量管理大师',
    166: '充电气氛组',
    179: '打工皮卡丘',
    0: '电量探险家'
  },
  tagP6: [
    '被窝守夜人',
    '日出收藏家',
    '养生达人'
  ]
}

class BillItem { // 创建账单对象

  constructor(textList, attr, style, tag) { // 类构造器
    this.textList = textList;
    this.attr = attr;
    this.style = style;
    this.tag = tag
  }

  compose() { // 组装函数
    let res = [],
      regRule = new RegExp(/\${.*}/, 'i')
    res = this.textList.map((item, index) => {
      let resItem = []
      item.forEach(subItem => {
        for (let key in subItem) {
          let matchItemResult = subItem[key].match(regRule)
          if (!matchItemResult) {
            resItem.push(subItem)
          } else {
            let resSubItem = subItem
            resSubItem[key] = subItem[key].replace(matchItemResult[0], this.attr[matchItemResult[0].slice(2, -1)])
            resItem.push(resSubItem)
          }
        }
      })
      return { text: resItem, style: this.style.styleList[index] }
    })
    return { content: { dom: res, img: this.style.img, }, tag: this.tag }
  }
}

let rootObj = {} // 根对象

let attrObjGen = {} // 生成的属性对象

let textObjGen = {} // 生成的文案对象

let styleObjGen = {} // 生成的样式对象


export default {

  name: 'BillPage',

  components: {
    Swiper,
    SwiperSlide,
    BillAudio
  },

  props: { // 父组件属性对象
    info: {
      type: Object,
      required: false
    },
    activityId: { // 活动id
      type: String,
      required: true
    },
    openId: { // openId
      type: String,
      required: true
    },
    activityStatus: {  // 活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束")
      type: Number,
      required: true
    },
    nickName: { // 昵称
      type: String,
      required: true
    },
    targetId: { // 目标活动id
      type: String,
      required: true
    }
  },

  data() {
    return {
      ruleOption: {}, // 规则配置
      swiperOptions: { // swiper 配置项
        initialSlide: 0,
        direction: 'vertical',
        width: '100%',
        height: window.innerHeight,
        autoplay: false,
        loop: false,
        loopedSlides: 10,
        on: {
          slideChangeTransitionStart: () => {
            let activeSwiper = this.swiperList[this.swiper.activeIndex]
            this.activeSwiper = activeSwiper
          }
        }
      },
      activeSwiper: {}, // 当前激活swiper
      swiperStyle: { // 
      },
      screenRatio: screenRatio, // 屏幕比例
      widthPercent, // 屏幕宽高度比例
      widthRatio, // 屏幕宽度比例
      swiperList: [], // swiper内容列表
      imgs: imgs,
      audioOptions: { // 音频配置
        playUrl: imgs.musicOpen,
        stopUrl: imgs.musicClosed,
        audioUrl: imgs.audio
      },
      newUser: true,
      isWechat: isWechat
    }
  },

  computed: {

    swiper() {
      return this.$refs.swiperInstance.$swiper
    },

    showAudio() {
      return this.swiperList.length != 1 && this.activeSwiper.tag !== 'part7'
    },

    showSlider() {
      return this.swiperList.length != 1 && this.activeSwiper.tag !== 'part7'
    }

  },

  mounted() {
    this.formatData()
    this.initBill()
  },

  methods: {

    formatData() { // 格式化配置项数据
      this.ruleOption = this.info.props.imgList.ruleOption;
    },

    initBill() { // 初始化账单
      if (this.activityStatus == 2) {
        this.toastFun('活动暂未开始')
      } else if (this.activityStatus == 3) {
        this.getBillData()
      } else {
        this.toastFun('活动已经结束')
      }
    },

    toastFun(txt) { // toast 函数
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: txt,
        duration: 2000
      }).then(() => {
        console.log("finish");
      });
    },

    getBillData() { // 获取账单数据
      let params = {
        activityId: this.activityId,
        openId: this.openId
      }
      this.$fetch({
        url: '/ehs/activity/user/annualBill', method: 'post'
      }, params).then(res => {
        if (res.success) {
          let data = res.model
          try {
            let val = this.validateData(data)
            this.newUser = val.newUser
            this.transferProperty(val)
            this.initBillPage(this.transfterData(val))
          } catch (e) {
            console.log('校验出错', e)
            let val = this.defaultData(null)
            this.newUser = val.newUser
            this.transferProperty(val)
            this.initBillPage(this.transfterData(val))
          }
        } else {
          let val = this.defaultData(null)
          this.newUser = val.newUser
          this.transferProperty(val)
          this.initBillPage(this.transfterData(val))
        }
      }).catch(_ => {
        let val = this.defaultData(null)
        this.newUser = val.newUser
        this.transferProperty(val)
        this.initBillPage(this.transfterData(val))
      })
    },

    validateData(data) { // 对 BI 数据进行 校验 修复等操作
      let val = {}
      if (data.newUser) {
        val = Object.assign(data, {
          userId: data.userId,
          luckyWord: luckyWordList.hasOwnProperty(data.luckyWord - 1) ? data.luckyWord : 1,
          newUser: data.newUser,
        })
      } else {
        val = Object.assign(data, {
          userId: data.userId,
          regDurationYear: data.regDurationYear || '',
          firstRegDate: data.firstRegDate,
          firstOrderDate: data.firstOrderDate,
          firstOrderElapsedDuration: data.firstOrderElapsedDuration || '',
          firstOrderCity: data.firstOrderCity || '',
          useDuration: data.useDuration || '',
          overTenHours: data.overTenHours,
          rankPercent: data.rankPercent || '',
          tiktokDuration: transferTiktok(data.tiktokDuration) || '',
          tvDuration: data.tvDuration || '',
          gameDuration: data.gameDuration || '',
          orderQt: data.orderQt || '',
          firstOrderMonthByP3: data.firstOrderMonthByP3 || 0,
          orderCityQt: data.orderCityQt,
          orderCityList: data.orderCityList && Array.isArray(data.orderCityList) ? data.orderCityList.slice(0, 3) : [],
          orderMostCategory: shopInfo.hasOwnProperty(data.orderMostCategory) ? data.orderMostCategory : 0,
          orderMostCategoryQt: data.orderMostCategoryQt || '',
          latestOrderDate: data.latestOrderDate || '',
          earliestOrderDate: data.earliestOrderDate || '',
          luckyWord: luckyWordList.hasOwnProperty(data.luckyWord) ? data.luckyWord : 1,
          tagP2: tag.tagP2.hasOwnProperty(data.tagP2 - 1) ? data.tagP2 : 1,
          tagP3: tag.tagP3.hasOwnProperty(data.tagP3 - 1) ? data.tagP3 : 1,
          tagP4: tag.tagP4.hasOwnProperty(data.tagP4 - 1) ? data.tagP4 : 1,
          tagP5: tag.tagP5.hasOwnProperty(data.tagP5) ? data.tagP5 : 0,
          tagP6: tag.tagP6.hasOwnProperty(data.tagP6 - 1) ? data.tagP6 : 1,
          newUser: data.newUser
        })

        function transferTiktok(hour) {
          if (!hour) {
            return ''
          } else {
            return parseFloat(hour)
          }
        }
      }
      return val
    },

    defaultData() { // 返回缺省数据
      let defaultObj = {
        newUser: true,
        luckyWord: 1
      }
      return defaultObj
    },

    transferProperty(data) { // 根据 BI 返回的数据 对预置对象进行改写
      if (data.newUser) {
        rootObj = {
          part7: {
            a: true
          }
        }
      } else {
        rootObj = {
          part1: true,
          part2: {},
          part3: {},
          part4: {},
          part5: true,
          part6: {},
          part7: { b: true }
        }
        if (!data.overTenHours) {
          rootObj.part2.a = true
        } else {
          rootObj.part2.b = true
        }
        if (data.firstOrderMonthByP3) {
          rootObj.part3.a = true
        } else {
          rootObj.part3.b = true
        }
        if (data.orderCityList.length > 1) { // 这里 
          rootObj.part4.b = true
        } else {
          rootObj.part4.a = true
        }
        if (data.latestOrderDate) {
          rootObj.part6.a = true
        } else if (data.earliestOrderDate) {
          rootObj.part6.b = true
        } else {
          rootObj.part6.c = true
        }
      }

      for (let key in rootObj) {
        if (typeof rootObj[key] == 'boolean') {
          textObjGen[key] = textObj[key]
          attrObjGen[key] = attrObj[key]
          styleObjGen[key] = styleObj[key]
        } else {
          for (let childKey in rootObj[key]) {
            textObjGen[key] = textObj[key][childKey]
            attrObjGen[key] = attrObj[key][childKey]
            styleObjGen[key] = styleObj[key][childKey]
          }
        }
      }

    },

    transfterData(data) { // 处理 BI 返回的数据 增加额外自定义属性
      if (data.newUser) {
        let addtionalAttr = {
          nickName: this.nickName,
          luckyWordTxt: data.luckyWord && luckyWordList[data.luckyWord - 1] || '',
        }
        return Object.assign({}, data, addtionalAttr)
      } else {
        let latestOrderDate = []
        let earliestOrderDate = []
        if (data.latestOrderDate) {
          latestOrderDate = transferDate(data.latestOrderDate)
        }
        if (data.earliestOrderDate) {
          earliestOrderDate = transferDate(data.earliestOrderDate)
        }
        let addtionalAttr = {
          nickName: this.nickName,
          orderCityListTxt: data.orderCityList.join('、') + `${data.orderCityQt > 3 ? '......' : ''}`,
          orderMostCategoryTxt: shopInfo[data.orderMostCategory] && shopInfo[data.orderMostCategory].name || (shopInfo[0].name || ''),
          orderMostCategoryInfo1: shopInfo[data.orderMostCategory] && shopInfo[data.orderMostCategory].desc[0] || (shopInfo[0].desc[0] || ''),
          orderMostCategoryInfo2: shopInfo[data.orderMostCategory] && shopInfo[data.orderMostCategory].desc[1] || (shopInfo[0].desc[1] || ''),
          orderMostCategoryInfo3: shopInfo[data.orderMostCategory] && shopInfo[data.orderMostCategory].desc[2] || (shopInfo[0].desc[2] || ''),
          latestOrderDateMonth: latestOrderDate.length && (latestOrderDate[0] || ''),
          latestOrderDateDay: latestOrderDate.length && (latestOrderDate[1] || ''),
          latestOrderDateHour: latestOrderDate.length && (latestOrderDate[2] || ''),
          earliestOrderDateMonth: earliestOrderDate.length && (earliestOrderDate[0] || ''),
          earliestOrderDay: earliestOrderDate.length && (earliestOrderDate[1] || ''),
          earliestOrderHour: earliestOrderDate.length && (earliestOrderDate[2] || ''),
          luckyWordTxt: data.luckyWord && luckyWordList[data.luckyWord - 1] || '',
          tagP2Txt: tag.tagP2[data.tagP2 - 1] || '',
          tagP3Txt: tag.tagP3[data.tagP3 - 1] || '',
          tagP4Txt: tag.tagP4[data.tagP4 - 1] || '',
          tagP5Txt: tag.tagP5[data.tagP5] || '',
          tagP6Txt: tag.tagP6[data.tagP6 - 1] || ''
        }

        function transferDate(date) {
          let group = date.split(' ')
          if (group.length <= 1) {
            return []
          } else {
            let subGroup1 = group[0].split('-')
            let subGroup2 = group[1].split(':')
            let [month, day, hour] = [subGroup1[1], subGroup1[2], subGroup2[0]]
            month = month < 10 ? month.slice(1) : month
            day = day < 10 ? day.slice(1) : day
            return [month, day, hour]
          }
        }

        return Object.assign({}, data, addtionalAttr)
      }
    },

    initBillPage(data) { // 根据数据初始化页面
      for (let key in attrObjGen) {
        for (let prop in attrObjGen[key]) {
          attrObjGen[key][prop] = data[prop]
        }
      }
      let swiperList = []
      for (let key in rootObj) {
        let swiperItem = new BillItem(textObjGen[key], attrObjGen[key], styleObjGen[key], key).compose()
        swiperList.push(swiperItem)
      }
      this.swiperList = swiperList
    },

    handleClick(str) { // 处理跳转事件
      const that = this
      if (str == "rule") {
        that.addLottory()
        that.$emit("handleGridClick", this.ruleOption);
        that.$log.senLog({
          pointID: '12020002',
          eventType: 2,
          businessData: {
            source: isWechat ? 'WUC' : 'ZUC'
          }
        })
      } else if (str == 'swiper') {
        that.activeSwiper = that.swiperList[0]
        that.swiper.slideTo(0, 100, false)
      }
    },

    addLottory() { // 增加抽奖机会
      let params = {
        activityId: this.targetId,
        openId: this.openId
      };
      this.$fetch(
        { url: "/ehs/activity/user/addLotteryEnergy", method: "post" },
        params
      ).then(res => { }, rej => { })
    },

  }

}

</script>

<style lang="scss" scoped>
.swiper-wrapper {
  width: 100%;
  height: 100vh;
  position: relative;

  .swiper-item {
    width: 100%;
    height: 100%;
    background-position-x: 0;
    background-position-y: bottom;
    background-size: 750px 1624px;
    background-repeat: no-repeat;
    background-color: #1683A0;
    position: relative;

    &.swiper-item-part7 {
      background-position-y: top;
      background-color: #51C2C2;

      &.swiper-item-part7-x {
        background-position-y: bottom;
        background-color: #0C91B1;
      }
    }
  }

  .swiper-line {
    font-size: 0;
    font-weight: 400;
    line-height: 68px;

    .line-item {
      font-size: 32px;
      color: #FFFFFF;

      &.line-item-em {
        color: #FFF1AA;
        font-size: 42px;
      }
    }
  }

  .cover-city {
    position: absolute;
    bottom: 48px;
    left: 40px;
    text-align: left;
    color: #fff;
    font-size: 24px;
  }

  .part7 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .part7-content {
      width: 714px;
      height: 1066px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      position: relative;

      .logo {
        position: absolute;
        width: 210px;
        height: 212px;
        right: 24px;
        bottom: 178px;
      }

      .qrcode-wrapper {
        position: absolute;
        width: 150px;
        height: 150px;
        border-radius: 150px;
        overflow: hidden;
        left: 56px;
        bottom: 58px;
      }

      .qrcode {
        width: 100%;
        height: 100%;
      }
    }

    .capture-tips {
      color: #fff;
      font-size: 24px;
      font-weight: 500;

      &.capture-tips-s {
        margin-top: -5px;
      }
    }

    .handle-btn {
      display: flex;
      flex-direction: row;
      width: 662px;
      align-items: center;
      margin-top: 20px;

      &.handle-double {
        justify-content: space-between;

        .btn-item {
          color: #DB3307;
          width: 300px;
          background: linear-gradient(180deg, #FFFFFF 0%, #FFFEFD 100%);
          border: 2px solid #fff;
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);

          &.reverse-item {
            color: #fff;
            background-image: none;
            background-color: transparent;
          }
        }
      }

      &.handle-single {
        justify-content: center;

        .btn-item {
          color: #DB3307;
          background-color: #fff;
          border: 2px solid #fff;
          width: 400px;
        }
      }

      &.handle-btn-s {
        margin-top: 10px;
      }
    }

    .btn-item {
      font-size: 40px;
      font-weight: 600;
      text-align: center;
      height: 88px;
      line-height: 88px;
      box-sizing: border-box;
      border-radius: 60px;
    }
  }
}

.audio-wrapper {
  position: absolute;
  width: 64px;
  height: 64px;
  top: 40px;
  right: 40px;
  z-index: 10;

  .audio-img {
    width: 100%;
    height: 100%;
  }
}

.slide-tips {
  position: absolute;
  bottom: 120px;
  z-index: 10;
  left: 347px;

  .slide-icon {
    width: 56px;
    height: 116px;
    position: relative;
    animation: upDown ease-in-out 1.5s infinite;
  }
}

@keyframes upDown {
  0% {
    top: -20px;
  }

  50% {
    top: 0;
  }

  100% {
    top: -20px;
  }
}

.swiper-container {
  width: 100%;
}
</style>